export const defaultState = {
  activeContracts: [],
  expiredContracts: [],
  selectedContract: {},
  positionRequestTypes: [],
};
